import { render } from "./WhatsAppFloat.vue?vue&type=template&id=523ce48a"
import script from "./WhatsAppFloat.vue?vue&type=script&lang=js"
export * from "./WhatsAppFloat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__